import React, { useEffect } from 'react'
import { useRequestsContext } from '../context/requests/requestsProvider'
import RequestsTable from '../components/requests-page/RequestsTable'
import useRequestsActions from '../hooks/useRequestsActions'
import Pagination from '../../core/components/UI/Pagination'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import LoaderRequestsGrid from '../components/requests-page/LoaderRequestsGrid'
import RequestsGrid from '../components/requests-page/RequestsGrid'

export default function SponsorRequestsPage() {
  const { requestsState } = useRequestsContext()
  const { getRequests } = useRequestsActions()
  // console.log(requestsState.requests)
  useEffect(() => {
    getRequests()
  }, [])
  const links = [
    {
      id: 1,
      label: `طلبات الرعاية`,
      isActive: true,
      to: '/sponsors/requests',
    },
  ]
  return (
    <>
      <Breadcrumb links={links} />
      {requestsState.isLoading ? (
        <LoaderRequestsGrid />
      ) : (
        <RequestsGrid requests={requestsState.requests} />
      )}
      <Pagination pagination={requestsState.pagination} />
    </>
  )
}
